"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var client_1 = require("@apollo/client");
var AcSetPhraseStampButton_1 = require("./AcSetPhraseStampButton");
var AcPdfSetPhraseMenu_1 = require("../sideSubMenus/AcPdfSetPhraseMenu");
var AcStampButtonWrapper_1 = require("./AcStampButtonWrapper");
var setPhraseRecentlyUsedKey = 'setPhraseRecentlyUsed';
var getFaxSetPhraseProps = function () {
    var value = localStorage.getItem(setPhraseRecentlyUsedKey);
    if (!value) {
        return [];
    }
    var props;
    try {
        props = JSON.parse(value);
    }
    catch (e) {
        props = [];
    }
    return props;
};
exports.setFaxSetPhraseIds = function (stamp) {
    if (stamp.type !== 'setPhrase' || !stamp.options) {
        return;
    }
    var faxSetPhrase = stamp.options;
    var faxSetPhraseId = faxSetPhrase.faxSetPhraseId, companyContractFaxId = faxSetPhrase.companyContractFaxId;
    if (!faxSetPhraseId || !companyContractFaxId) {
        return;
    }
    var props = getFaxSetPhraseProps();
    var prop = props.find(function (_prop) { return _prop.companyContractFaxId === companyContractFaxId; });
    if (!prop) {
        prop = { companyContractFaxId: companyContractFaxId, faxSetPhraseIds: [] };
        props.push(prop);
    }
    var index = prop.faxSetPhraseIds.indexOf(faxSetPhraseId);
    if (index >= 0) {
        prop.faxSetPhraseIds.splice(index, 1);
    }
    prop.faxSetPhraseIds.unshift(faxSetPhraseId);
    var maxLength = 20;
    var overLength = prop.faxSetPhraseIds.length - maxLength;
    if (overLength > 0) {
        prop.faxSetPhraseIds.splice(maxLength, overLength);
    }
    localStorage.setItem(setPhraseRecentlyUsedKey, JSON.stringify(props));
};
exports.AcSetPhraseRecentlyUsedButtons = function () {
    var setPhrasesRecentlyUsedButtons = [];
    var _a = client_1.useQuery(AcPdfSetPhraseMenu_1.queryAll), setPhrases = _a.data, error = _a.error;
    if (setPhrases && !error) {
        var faxSetPhrases_1 = setPhrases.viewer.faxSetPhrases;
        if (faxSetPhrases_1.length > 0) {
            var props = getFaxSetPhraseProps();
            var prop = props.find(function (_prop) { return _prop.companyContractFaxId === faxSetPhrases_1[0].companyContractFaxId; });
            if (!prop) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            prop.faxSetPhraseIds.forEach(function (id) {
                var foundSetPhrase = faxSetPhrases_1.find(function (faxSetPhrase) { return id === faxSetPhrase.faxSetPhraseId; });
                if (foundSetPhrase) {
                    setPhrasesRecentlyUsedButtons.push(react_1.default.createElement(AcSetPhraseStampButton_1.AcSetPhraseStampButton, { text: foundSetPhrase.setPhrase, key: foundSetPhrase.faxSetPhraseId }));
                }
            });
        }
    }
    if (setPhrasesRecentlyUsedButtons.length === 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { className: "fs-14 text-left text-primary mb-4 mt-2 mx-1" }, "\u3088\u304F\u4F7F\u308F\u308C\u308B\u9805\u76EE"),
        react_1.default.createElement(AcStampButtonWrapper_1.AcStampButtonWrapper, null, setPhrasesRecentlyUsedButtons)));
};
exports.AcSetPhraseRecentlyUsedButtons.displayName = 'AcSetPhraseRecentlyUsedButtons';
//# sourceMappingURL=AcSetPhraseRecentlyUsedButtons.js.map